var map = {
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"default~modules-auth-auth-module~modules-indicators-indicator-module~modules-profile-profile-module~~8884497d",
		"modules-auth-auth-module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"modules-dashboard-dashboard-module"
	],
	"./modules/errors/error.module": [
		"./src/app/modules/errors/error.module.ts",
		"modules-errors-error-module"
	],
	"./modules/indicators/indicator.module": [
		"./src/app/modules/indicators/indicator.module.ts",
		"default~modules-auth-auth-module~modules-indicators-indicator-module~modules-profile-profile-module~~8884497d",
		"modules-indicators-indicator-module"
	],
	"./modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"default~modules-auth-auth-module~modules-indicators-indicator-module~modules-profile-profile-module~~8884497d",
		"modules-profile-profile-module"
	],
	"./modules/users/user.module": [
		"./src/app/modules/users/user.module.ts",
		"default~modules-auth-auth-module~modules-indicators-indicator-module~modules-profile-profile-module~~8884497d",
		"modules-users-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;